module.exports = __webpack_public_path__ + "static/img/ico-banner-arrow-r.b0e0d5a0.svg";